import { render, staticRenderFns } from "./customStep.vue?vue&type=template&id=88b2dc02&scoped=true"
import script from "./customStep.vue?vue&type=script&lang=js"
export * from "./customStep.vue?vue&type=script&lang=js"
import style0 from "./customStep.vue?vue&type=style&index=0&id=88b2dc02&prod&lang=scss"
import style1 from "./customStep.vue?vue&type=style&index=1&id=88b2dc02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b2dc02",
  null
  
)

export default component.exports